import api from './api';

export const additionalPaymentService = {
  // Obtener listado de pagos adicionales
  getAll: (params?: any) => api.get('/additional-payments', { params }),
  
  // Obtener un pago específico
  getById: (id: number) => api.get(`/additional-payments/${id}`),
  
  // Crear nuevo pago adicional
  create: (data: any) => api.post('/additional-payments', data),
  
  // Actualizar pago adicional
  update: (id: number, data: any) => api.put(`/additional-payments/${id}`, data),
  
  // Eliminar pago adicional
  delete: (id: number) => api.delete(`/additional-payments/${id}`),
  
  // Marcar como pagado
  markAsPaid: (id: number) => api.post(`/additional-payments/${id}/mark-paid`),
  
  // Obtener resumen por estudiante
  getStudentSummary: (studentId: number) => api.get(`/students/${studentId}/additional-payments`),
  
  // Obtener conceptos disponibles
  getConcepts: () => api.get('/additional-payments-concepts')
};